export interface ChangeProfileAndAddressResponse {
  email_change_pending: boolean;
}

export interface ChangeProfileAndAddressModel {
  email: string | null;
  phone: string | null;
  first_name: string | null;
  last_name: string | null;
  nickname: string | null;
  description: string | null;
  gender: string | null;
  birthday: string | null;
  post_code: string | null;
  city: string | null;
  country: string | null;
  street: string | null;
  house_number: string | null;
  street_number: string | null;
  photo_id: string | null;
}
